import { bindActionCreators } from '@reduxjs/toolkit';
import { connect } from 'react-redux';

import Button from 'carbon-react/lib/components/button';
import Modal from 'carbon-react/lib/components/dialog';

import Translate from '../Translate/Translate';

import * as LocalActions from '../../redux/Local/actions';

const DeactivateCompanySuccessModal = ({ companyName, showHideDeactivateCompanyModal }) => {
  const onCancel = () => {
    showHideDeactivateCompanyModal(false);
  };

  return (
    <Modal
      disableEscKey={false}
      enableBackgroundUI={false}
      onCancel={onCancel}
      open={true}
      showCloseIcon={true}
      size="medium"
      title="Company Deactivated"
    >
      <div className="deactivate-company-success-modal">
        <div className="text">
          <p>
            <Translate scope="settings.advanced.SuccessMessageInModal" options={{ name: companyName }} />
          </p>
        </div>
        <div className="ok-button">
          <Button buttonType="primary" onClick={onCancel}>
            <Translate scope="settings.advanced.OK" />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  companyName: state.local.showDeactivateCompanyModal,
});

const mapDispatchToProps = (dispatch) => {
  const _local = bindActionCreators(LocalActions, dispatch);
  return {
    showHideDeactivateCompanyModal: _local.showHideDeactivateCompanyModal,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeactivateCompanySuccessModal);
